import { Grid, Skeleton, Stack, Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportCard from "../../components/reports/ReportCard";
import { mxReportPageLoad } from "../../utils/mixpanelEvents";
import { getOrganisationAvailableReports } from "redux/actions/reports/reportsData";

const EmptyReports = ({ type }) => {
  if (type === "ERROR") {
    return (
      <Box
        sx={{
          background: "#F5F7F6",
          height: "388px",
          padding: "30px",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <img src="/images/empty-reports.svg" alt="" />
        <Typography
          sx={{
            color: "#5C6469",
            fontWeight: "700",
            fontSize: "16px",
            marginTop: "40px",
          }}>
          Error fetching reports
        </Typography>
        <Typography
          sx={{
            color: "#5C6469",
            fontWeight: "400",
            fontSize: "14px",
            textAlign: "center",
            lineHeight: "24px",
            marginTop: "4px",
          }}>
          Unfortunately, there was some problem fetching reports
        </Typography>
      </Box>
    );
  }
  if (type === "EMPTY") {
    return (
      <Box
        sx={{
          background: "#F5F7F6",
          height: "388px",
          padding: "30px",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <img src="/images/empty-reports.svg" alt="" />
        <Typography
          sx={{
            color: "#5C6469",
            fontWeight: "700",
            fontSize: "16px",
            marginTop: "40px",
          }}>
          No reports available
        </Typography>
        <Typography
          sx={{
            color: "#5C6469",
            fontWeight: "400",
            fontSize: "14px",
            textAlign: "center",
            lineHeight: "24px",
            marginTop: "4px",
          }}>
          Unfortunately, this report is currently unavailable for you. <br /> If
          you think this is an error, please contact us at <br />{" "}
          support@doctustech.com
        </Typography>
      </Box>
    );
  }
};

// Reports page
const Reports = () => {
  const dispatch = useDispatch();
  const userOrganization = useSelector((e) => e.sidebar.organisation);
  const organisation_reports = useSelector(
    (e) => e.reports.organisationLevelReports
  );
  const loading_organisation_reports = useSelector(
    (e) => e.reports.isOrganisationReportsLoading
  );
  const error_organisation_reports = useSelector(
    (e) => e.reports.isOrganisationReportsError
  );
  useEffect(() => {
    mxReportPageLoad();
  }, []);

  useEffect(() => {
    if (userOrganization) {
      dispatch(
        getOrganisationAvailableReports({ userOrganization: userOrganization })
      );
    }
  }, [userOrganization]);

  if (loading_organisation_reports) {
    return (
      <Stack direction="row" spacing={4}>
        <Skeleton variant="rectangular" width={500} height={300} />
        <Skeleton variant="rectangular" width={500} height={300} />
      </Stack>
    );
  }

  if (error_organisation_reports) {
    return <EmptyReports type="ERROR" />;
  }

  if (!organisation_reports?.results.length) {
    return <EmptyReports type="EMPTY" />;
  }

  return (
    <>
      <Grid container spacing={1.5}>
        {organisation_reports &&
          organisation_reports?.results.map((report) => (
            <Grid key={report.mapping} item xs={12} sm={12} md={6} lg={4}>
              <ReportCard report={report} />
            </Grid>
          ))}
      </Grid>
    </>
  );
};

export default Reports;
